import React, { useEffect, useState } from "react";
import { InstallAppDialog } from "@/components/InstallAppDialog";
import { Smartphone, X } from "lucide-react";

export const InstallBanner = () => {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) return;
    if (sessionStorage.getItem("install-banner-dismissed")) return;
    const isMobile = /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
    if (isMobile) setHidden(false);
  }, []);

  const dismiss = (e) => {
    e.stopPropagation();
    setHidden(true);
    sessionStorage.setItem("install-banner-dismissed", "1");
  };

  if (hidden) return null;

  return (
    <InstallAppDialog
      trigger={
        <div
          className="bg-[#D4AF37] text-black px-4 py-2.5 flex items-center justify-between gap-3 cursor-pointer hover:bg-[#E5C158] transition-colors sm:hidden"
          data-testid="install-banner"
        >
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <Smartphone className="w-4 h-4 shrink-0" />
            <div className="text-sm font-bold leading-tight truncate">
              Installa l'app sulla home — è gratis
            </div>
          </div>
          <button onClick={dismiss} className="p-1 hover:bg-black/10 shrink-0" data-testid="install-banner-dismiss" aria-label="Chiudi">
            <X className="w-4 h-4" />
          </button>
        </div>
      }
    />
  );
};
